/* ========================================
   DAYS THEME: GALERIA DE PRODUTO
   Setas laterais + Bolinhas indicadoras
   ======================================== */

class DaysProductGallery {
  constructor() {
    // Buscar elemento <media-gallery> (web component do Shopify Dawn)
    this.gallery = document.querySelector('media-gallery');

    if (!this.gallery) return;

    // Adicionar classe CSS para compatibilidade com estilos
    this.gallery.classList.add('product__media-gallery');

    this.sliderComponent = document.querySelector('slider-component');

    // Buscar slides dentro da estrutura correta do Dawn
    this.mediaItems = this.gallery.querySelectorAll('li[id^="Slide-"]');
    this.totalSlides = this.mediaItems.length;
    this.currentSlide = 0;

    this.init();
  }

  init() {
    if (this.totalSlides <= 1) return; // Não precisa de navegação para produto com 1 imagem

    this.createArrows();
    this.createDots();
    this.observeSlideChanges();
  }

  createArrows() {
    const arrowsContainer = document.createElement('div');
    arrowsContainer.className = 'days-slider-arrows';

    // Botão anterior (←)
    const prevBtn = document.createElement('button');
    prevBtn.className = 'days-arrow-btn days-arrow-prev';
    prevBtn.setAttribute('aria-label', 'Imagem anterior');
    prevBtn.innerHTML = `
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 19.5L8.25 12l7.5-7.5" />
      </svg>
    `;
    prevBtn.addEventListener('click', () => this.navigate('prev'));

    // Botão próximo (→)
    const nextBtn = document.createElement('button');
    nextBtn.className = 'days-arrow-btn days-arrow-next';
    nextBtn.setAttribute('aria-label', 'Próxima imagem');
    nextBtn.innerHTML = `
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
      </svg>
    `;
    nextBtn.addEventListener('click', () => this.navigate('next'));

    arrowsContainer.appendChild(prevBtn);
    arrowsContainer.appendChild(nextBtn);

    // Garantir que galeria tem position relative
    this.gallery.style.position = 'relative';
    this.gallery.appendChild(arrowsContainer);
  }

  createDots() {
    const dotsContainer = document.createElement('div');
    dotsContainer.className = 'days-slider-dots';

    for (let i = 0; i < this.totalSlides; i++) {
      const dot = document.createElement('button');
      dot.className = 'days-slider-dot';
      if (i === 0) dot.classList.add('active');
      dot.setAttribute('aria-label', `Ir para imagem ${i + 1}`);
      dot.addEventListener('click', () => this.goToSlide(i));
      dotsContainer.appendChild(dot);
    }

    // Inserir após a galeria
    this.gallery.insertAdjacentElement('afterend', dotsContainer);
    this.dotsContainer = dotsContainer;
  }

  navigate(direction) {
    // Buscar a lista de slides (ul.product__media-list)
    const slider = this.gallery.querySelector('ul.product__media-list, ul[role="list"]');

    if (slider) {
      const slideWidth = slider.querySelector('li[id^="Slide-"]')?.offsetWidth || slider.offsetWidth;

      if (direction === 'next') {
        // Loop infinito: se estiver na última, volta para a primeira
        this.currentSlide = (this.currentSlide + 1) % this.totalSlides;
        slider.scrollTo({
          left: slideWidth * this.currentSlide,
          behavior: 'smooth'
        });
      } else {
        // Loop infinito: se estiver na primeira, vai para a última
        this.currentSlide = (this.currentSlide - 1 + this.totalSlides) % this.totalSlides;
        slider.scrollTo({
          left: slideWidth * this.currentSlide,
          behavior: 'smooth'
        });
      }

      this.updateDots();
    }
  }

  goToSlide(index) {
    this.currentSlide = index;
    this.updateDots();

    const slider = this.gallery.querySelector('ul.product__media-list, ul[role="list"]');
    if (slider) {
      const slideWidth = slider.querySelector('li[id^="Slide-"]')?.offsetWidth || slider.offsetWidth;
      slider.scrollTo({
        left: slideWidth * index,
        behavior: 'smooth'
      });
    }
  }

  observeSlideChanges() {
    // Observar mudanças de slide usando Intersection Observer
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const index = Array.from(this.mediaItems).indexOf(entry.target);
          if (index !== -1 && index !== this.currentSlide) {
            this.currentSlide = index;
            this.updateDots();
          }
        }
      });
    }, {
      threshold: 0.5,
      root: this.gallery.querySelector('ul.product__media-list, ul[role="list"]')
    });

    this.mediaItems.forEach(item => observer.observe(item));
  }

  updateDots() {
    if (!this.dotsContainer) return;

    const dots = this.dotsContainer.querySelectorAll('.days-slider-dot');
    dots.forEach((dot, index) => {
      dot.classList.toggle('active', index === this.currentSlide);
    });
  }
}

// Inicializar quando o DOM estiver pronto
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new DaysProductGallery();
  });
} else {
  new DaysProductGallery();
}
